<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row text-purple-manax filter-text px-3 pt-2">
      Fecha:&nbsp;&nbsp;
      <select class="filter small" [(ngModel)]="selectDate" (ngModelChange)="recalculateDay()"
        (click)="$event.stopPropagation()" width="200px" style="max-width: 200px;">
        <option [ngValue]="'currentMonth'"> Mes actual </option>
        <option [ngValue]="'lastMonth'"> Mes pasado </option>
        <option [ngValue]="'today'"> Hoy </option>
        <option [ngValue]="'personalized'"> Personalizado </option>
      </select>&nbsp;
      <input type="date" class="filter small" [(ngModel)]="selectedDayStart" (ngModelChange)="recalculateDay()"
        *ngIf="selectDate === 'personalized'" (click)="$event.stopPropagation()"
        (keydown.space)="$event.stopPropagation()" style="max-width: 120px;" />&nbsp;
      <input type="date" class="filter small" [(ngModel)]="selectedDayEnd" (ngModelChange)="recalculateDay()"
        *ngIf="selectDate === 'personalized'" (click)="$event.stopPropagation()"
        (keydown.space)="$event.stopPropagation()" style="max-width: 120px;" />
    </div>

    <div class="row">

      <!-- Solicitudes-->
      <div class="col-12 col-md-3 cursor-pointer" (click)="redirectTaskRequests()">
        <div class="card">
          <div class="card-body pt-0">
            <div class="row px-3 pt-3 pb-1 align-items-center">
              <div class="col-12 px-0 d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center text-purple-manax">
                  <i class="material-icons">move_to_inbox</i>&nbsp;<h5 class="my-0">Solicitudes</h5>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-center" *ngIf="loadingTaskRequests">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>

            <div class="row text-purple-manax px-3 align-items-end mb-2" *ngIf="!loadingTaskRequests">
              <h5 class="m-0 main-number-card ">{{taskRequests?.pending}}</h5>&nbsp;<h5 class="my-0 main-info-card">
                Pendientes</h5>
            </div>
            <div class="row secondary-info-card text-purple-manax px-3" *ngIf="!loadingTaskRequests">
              <div class="col-12 px-0">
                Aprobadas: {{taskRequests?.accepted}}
              </div>
              <div class="col-12 px-0">
                Rechazadas: {{taskRequests?.rejected}}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Presupuestos -->
      <div class="col-12 col-md-3 cursor-pointer" (click)="redirectQuotes()">
        <div class="card">
          <div class="card-body pt-0">
            <div class="row px-3 pt-3 pb-1 align-items-center">
              <div class="col-12 px-0 d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center text-purple-manax">
                  <i class="material-icons">request_quote</i>&nbsp;<h5 class="my-0">Presupuestos</h5>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-center" *ngIf="loadingQuotes">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>

            <div class="row text-purple-manax px-3 align-items-end mb-2" *ngIf="!loadingQuotes">
              <h5 class="m-0 main-number-card ">{{quotes?.scheduled}}</h5>&nbsp;<h5 class="my-0 main-info-card">
                Aprobados</h5>
            </div>
            <div class="row secondary-info-card text-purple-manax px-3" *ngIf="!loadingQuotes">
              <div class="col-12 px-0">
                Pendientes: {{quotes?.quoted}}
              </div>
              <div class="col-12 px-0">
                Cancelados: {{quotes?.cancelled}}
              </div>
              <div class="col-12 px-0">
                &nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Trabajos -->
      <div class="col-12 col-md-3 cursor-pointer" (click)="redirectTasks()">
        <div class="card">
          <div class="card-body pt-0">
            <div class="row px-3 pt-3 pb-1 align-items-center">
              <div class="col-12 px-0 d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center text-purple-manax">
                  <i class="material-icons">business_center</i>&nbsp;<h5 class="my-0">Trabajos</h5>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-center" *ngIf="loadingTask">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>

            <div class="row text-purple-manax px-3 align-items-end mb-2" *ngIf="!loadingTask">
              <h5 class="m-0 main-number-card ">{{tasks?.completed}}</h5>&nbsp;<h5 class="my-0 main-info-card">
                Completados</h5>
            </div>
            <div class="row secondary-info-card text-purple-manax px-3" *ngIf="!loadingTask">
              <div class="col-12 px-0">
                Pendientes: {{tasks?.pending}}
              </div>
              <div class="col-12 px-0">
                En Curso: {{tasks?.ongoing}}
              </div>
              <div class="col-12 px-0">
                Facturados: {{tasks?.invoiced}}
              </div>
              <div class="col-12 px-0">
                Cancelados: {{tasks?.cancelled}}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Facturas -->
      <div class="col-12 col-md-3 cursor-pointer" (click)="redirectBillDocs()">
        <div class="card">
          <div class="card-body pt-0">
            <div class="row px-3 pt-3 pb-1 align-items-center">
              <div class="col-12 px-0">
                <div class="d-flex align-items-center text-purple-manax">
                  <i class="material-icons">paid</i>&nbsp;
                  <h5 class="my-0">Facturas</h5>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-center" *ngIf="loadingInvoices">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>

            <div class="row text-purple-manax px-3 align-items-end mb-2" *ngIf="!loadingInvoices">
              <h5 class="m-0 main-number-card pull-left">{{invoices?.paid}}</h5>&nbsp;
              <h5 class="my-0 main-info-card pull-left">Pagadas</h5>&nbsp;&nbsp;&nbsp;&nbsp;
              <h5 class="my-0 detail-info-card text-lilac-manax pull-right">{{invoices?.total }}</h5>
            </div>
            <div class="row secondary-info-card text-purple-manax px-3" *ngIf="!loadingInvoices">
              <div class="col-12 px-0">
                Emitidas: {{invoices?.issued}}
              </div>
              <div class="col-12 px-0">
                Borradores: {{invoices?.draft}}
              </div>
              <div class="col-12 px-0">

              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- Ventas -->
      <div class="col-12 col-md-6 cursor-pointer" (click)="redirectBillDocs()">
        <div class="card">
          <div class="card-body pt-0">
            <div class="row px-3 pt-3 pb-2 align-items-center">
              <div class="col-12 px-0">
                <h3 class="mt-0 pb-2 subtitle-graphic text-purple-manax mb-0">Ventas</h3>
                <select class="filter small mb-2" [(ngModel)]="selectDateSales" (ngModelChange)="recalculateSales()"
                  (click)="$event.stopPropagation()" width="200px" style="max-width: 200px;">
                  <option [ngValue]="'currentYear'"> Año actual </option>
                  <option [ngValue]="'lastYear'"> Año pasado </option>
                </select>
              </div>
            </div>

            <div class="d-flex justify-content-center" *ngIf="loadingSales">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>

            <div class="ct-chart" style="height: 300px;"></div>

          </div>
        </div>
      </div>

      <!-- Fichajes horarios -->
      <div class="col-12 col-md-6 cursor-pointer" (click)="redirectTimeTracks()">
        <div class="card">
          <div class="card-body pt-0">
            <div class="row px-3 pt-3 pb-2 align-items-center">
              <div class="col-12 px-0">
                <h3 class="mt-0 mb-0 pb-2 subtitle-graphic text-purple-manax">Fichajes</h3>
                <input type="date" class="filter small mb-2" [(ngModel)]="selectDateTimeTrack"
                  (ngModelChange)="recalculateTimeTrack()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 120px; height: 20px;" [max]="maxDate" />
              </div>
            </div>

            <div class="d-flex justify-content-center" *ngIf="loadingTimeTracks">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>

            <div id="pastel" style="height: 300px; stroke: white;"></div>
            <!-- <div class="d-flex justify-content-center" *ngIf="loadingTimeTracks">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>

            <div class="row px-3 justify-content-center" *ngIf="!loadingTimeTracks">
              <dx-pie-chart id="pie" [dataSource]="timeTracks" [palette]="['#2D572C', '#d60606']">
                <dxi-series argumentField="label" valueField="value"></dxi-series>
                <dxo-size [width]="500"></dxo-size>
              </dx-pie-chart>
            </div> -->

          </div>
        </div>
      </div>
    </div>

  </div>
</div>